import { render } from "./ItemList.vue?vue&type=template&id=f8a2d750&scoped=true&ts=true"
import script from "./ItemList.vue?vue&type=script&lang=ts"
export * from "./ItemList.vue?vue&type=script&lang=ts"

import "./ItemList.vue?vue&type=style&index=0&id=f8a2d750&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8a2d750"]])

export default __exports__